import { render, staticRenderFns } from "./ChangeAvatarModal.vue?vue&type=template&id=40000dbb&scoped=true"
import script from "./ChangeAvatarModal.vue?vue&type=script&lang=js"
export * from "./ChangeAvatarModal.vue?vue&type=script&lang=js"
import style0 from "./ChangeAvatarModal.vue?vue&type=style&index=0&id=40000dbb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40000dbb",
  null
  
)

export default component.exports